const accordionItemTokens = ({
  borders,
  colors,
  space,
  fontSizeBody,
  fontWeights,
  iconSizes,
}) => ({
  borders: {
    borderBottomWidth: borders[1],
  },
  colors: {
    borderColorSmall: colors.neutrals[5],
    borderColorBig: colors.neutrals[6],
    headerColor: colors.neutrals[0],
    headerHoverColor: colors.brandPrimary['30'],
    arrowColorClosedMd: colors.brandPrimary[1],
    arrowColorOpendMd: colors.neutrals[2],
    titleColor: colors.neutrals[2],
  },
  space: {
    pxAccordion: space[2],
    pxAccordionPromotional: space[4],
    ptBoxContainer: space[0],
    pyHeaderPositive: space[3],
    pxHeaderPositive: space[2],
    pxHeaderPromotional: space[4],
  },
  fontSizes: {
    fontSizeHeaderPositive: fontSizeBody[1],
    fontSizeHeaderDefault: fontSizeBody[3],
    fontSizeMdHeaderDefault: fontSizeBody[2],
  },
  fontWeights: {
    fontWeightHeader: fontWeights.normal,
    fontWeightHeaderOpened: fontWeights.bold,
  },
  iconSizes: {
    arrowIconSize: iconSizes.small,
  },
});

export default accordionItemTokens;
